import React, { Component } from 'react'
import { Box, CustomizedErrorMessage } from '../../styles.style'
import { DateInput } from '../../../../components/form-components/inputs.component'

class DocumentBirthDate extends Component {
	constructor(props) {
		super(props)
		this.state = {
			birthValid: false,
			birthDateError: ''
		}
	}

	nextPage = () => {
		const isValid = this.validateDate()
		if (!isValid) return

		this.props.handleSetBirthDate(this.props.values.birthDate)
		this.props.nextStep()
	}

	validateDate = () => {
		const { birthDate } = this.props.values

		let birthDateBr = birthDate
			.split('-')
			.reverse()
			.join('/')

		let errorMessage = ''

		const datePattern = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/([0-9]{4})$/

		if (!birthDateBr) {
			errorMessage = 'Informe a data de nascimento'
		} else if (!datePattern.test(birthDateBr)) {
			errorMessage = 'Data inválida.'
		}

		this.setState({ birthDateError: errorMessage, birthValid: !errorMessage })

		return !errorMessage
	}

	handleCompleteDateField = () => {
		this.validateDate()
	}

	render() {
		const { errors, touched } = this.props
		const { birthDateError } = this.state

		let isDisabled =
			!this.state.birthValid ||
			birthDateError ||
			(errors && errors.birthDate && touched.birthDate)

		return (
			<Box>
				<div className="field">
					<header>
						<h5>Nos informe sua data de nascimento</h5>
					</header>
					<DateInput
						id="birthDate"
						onComplete={this.handleCompleteDateField}
						placeholder="dd/mm/aaaa"
						{...this.props}
					/>
					{birthDateError && (
						<CustomizedErrorMessage>
							{birthDateError}
						</CustomizedErrorMessage>
					)}
				</div>
				<footer className="footer">
					<button
						className="button transparent"
						type="button"
						onClick={() => this.props.prevStep()}>
						Voltar
					</button>
					<button
						disabled={isDisabled}
						className={isDisabled ? 'disabled button' : 'button'}
						type="button"
						onClick={() => this.nextPage()}>
						Próximo
					</button>
				</footer>
			</Box>
		)
	}
}

export default DocumentBirthDate
